module.exports = __webpack_public_path__ + "assets/img/icon3.c18bfab9.png";